<template>
  <BaseLimitManagement
    :items="items"
    :selected="itemsSelected"
    :loading="loading"
    @delete="deleteSelected"
  >
    <template v-slot:listItem="{ item }">
      <v-checkbox
        :input-value="item.selected"
        @change="selectItem(item)"
      ></v-checkbox>
      <div class="content-wrapper">
        <IsOwnerIndicator
          :is-owner="false"
          height="24px"
          class="mx-3"
          :tooltip="$t('message.common.competitorsFacility')"
        />
        <div>
          <p class="name">{{ item.name }}</p>

          <p class="address">
            {{ item.formatted_address }}
          </p>
        </div>
      </div>
      <v-icon class="compare-icon" size="21px">mdi-arrow-left-right</v-icon>
      <div class="content-wrapper">
        <IsOwnerIndicator
          is-owner
          height="24px"
          class="mx-3"
          :tooltip="$t('message.common.yourFacility')"
        />
        <div>
          <p class="name">
            {{ item.related_gmb_address.name }}
          </p>
          <p class="address">
            {{ item.related_gmb_address.formatted_address }}
          </p>
        </div>
      </div>
    </template>
  </BaseLimitManagement>
</template>

<script>
import BaseLimitManagement from "./BaseLimitManagement.vue";
import IsOwnerIndicator from "@/components/Permissions/IsOwnerIndicator.vue";
import limitsService from "@/services/limits";
import { limitsMixin } from "@/helpers/mixins/limits";

export default {
  name: "CompetitorsLimitManagement",
  components: {
    BaseLimitManagement,
    IsOwnerIndicator
  },
  mixins: [limitsMixin],

  data() {
    return {
      height: 22,
      color: "primary"
    };
  },
  methods: {
    itemsFetchHandler() {
      return limitsService.getCompetitors();
    },
    itemDeleteHandler(id) {
      return limitsService.deleteCompetitor(id);
    }
  },
  computed: {
    selectedItemsIds() {
      return this.items
        .filter(item => item.selected)
        .map(item => `${item.related_gmb_address.id}/${item.id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.compare-icon {
  margin: 0 $spacing * 2;
}

.content-wrapper {
  display: flex;
  align-items: center;
}

.name {
  @include font-size(14px);
  font-weight: 500;
  margin-top: $spacing * 0.5;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: $dark;
}

.address {
  @include font-size(12px);
  margin-right: $spacing;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  font-weight: 400;
  white-space: nowrap;
}
</style>
